import React from "react";

function PolicyholderTerms() {
  return (
    <div className="py-6">
      <p className="mb-10">Effective Date: March 18, 2025</p>

      <h2 className="font-bold text-xl mb-2">1. Acceptance of Terms</h2>
      <p className="mb-10">
        By accessing or using our applications (“Applications”), you acknowledge
        that you have read, understood, and agree to be bound by these Terms and
        Conditions of Service (“Terms”). If you do not agree to these Terms, you
        must not access or use the Applications.
      </p>

      <h2 className="font-bold text-xl mb-2">2. Changes to Terms</h2>
      <p className="mb-10">
        We reserve the right to modify these Terms at any time. Changes will be
        effective immediately upon posting the updated Terms within the
        Applications. Continued use of our Applications after any modifications
        constitutes acceptance of the revised Terms. It is your responsibility
        to review these Terms regularly.
      </p>

      <h2 className="font-bold text-xl mb-2">3. Privacy Policy</h2>
      <p className="mb-10">
        Your use of our Applications is also governed by our Privacy Policy.
        Please review our Privacy Policy to understand our data practices,
        including how we collect, use, disclose, and safeguard your data.
      </p>

      <h2 className="font-bold text-xl mb-2">4. User Eligibility</h2>
      <p className="mb-10">
        You must be at least 18 years old to use our Applications. By using our
        Applications, you represent and warrant that you are of legal age.
      </p>

      <h2 className="font-bold text-xl mb-2">5. Access to and Use of Data</h2>
      <p className="mb-8">
        Our applications connect to your wearable health trackers to collect and
        analyze physiological data. By using our applications, you grant us
        permission to access, collect, store, and use this data for providing
        personalized health insights and for generating insurance analytics. You
        acknowledge and agree that analytics generated using your health data
        may be shared with your insurance company for analytics purposes.
      </p>
      <p className="mb-8">
        You acknowledge and agree that any analytics, insights, or
        recommendations generated using your health data are provided for
        informational purposes only, and any use of such analytics by you or your insurance company is at your sole risk. We
        shall not be liable for any decisions or actions taken based on these
        analytics.
      </p>

      <h2 className="font-bold text-xl mb-2">
        6. Health Information and Disclaimers
      </h2>
      <p>
        Our applications provide health insights based on the data collected
        from your wearable device. This information does not constitute medical
        advice. Always consult a healthcare professional for any medical
        concerns. We are not responsible for the accuracy or reliability of data
        provided by wearable health trackers or the results provided by the
        Artificial Intelligence techniques integrated in our applications.
      </p>

      <h2 className="font-bold text-xl mb-2">7. Intellectual Property</h2>
      <p className="mb-8">
        All content, materials, and software provided on our applications,
        including text, graphics, logos, images, and code, are our intellectual
        property and are protected by intellectual property laws. Nothing in these Terms grants you any rights
        to our Intellectual Property.
      </p>

      <h2 className="font-bold text-xl mb-2">8. User Conduct</h2>
      <p>You agree not to:</p>
      <ul className="list-disc ml-6 mb-10">
        <li>
          Use our applications for any unlawful purpose or in violation of these
          Terms.
        </li>
        <li>Share false or misleading information through our applications.</li>
        <li>
          Attempt to bypass or disrupt the security features of our
          applications.
        </li>
        <li>
          Reverse engineer, decompile, or disassemble any portion of our
          applications.
        </li>
        <li>
          Engage in conduct that harms or infringes upon the rights of others.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">9. Data Security</h2>
      <p className="mb-8">
        We employ commercially reasonable measures to protect your data from
        unauthorized access, disclosure, alteration, or destruction. However, no
        security system is completely foolproof, and we cannot guarantee the
        absolute security of your data. You acknowledge that you use our
        applications at your own risk.
      </p>

      <h2 className="font-bold text-xl mb-2">10. Termination</h2>
      <p className="mb-8">
        We reserve the right to suspend or terminate your access to our
        applications at any time, with or without cause and without prior
        notice. Upon termination, you must immediately cease using our
        applications.
      </p>

      <h2 className="font-bold text-xl mb-2">
        11. Disclaimers and Limitation of Liability
      </h2>
      <p className="mb-8">
        Our applications are provided “as is” and “as available” without any
        warranties, express or implied, including warranties of merchantability,
        fitness for a particular purpose, or non-infringement. We are not liable
        for any direct, indirect, incidental, special, or consequential damages
        arising from your use of our applications.
      </p>

      <h2 className="font-bold text-xl mb-2">12. Indemnification</h2>
      <p className="mb-10">
        You agree to indemnify, defend, and hold harmless our Institute and its affiliates, officers, directors, employees, and agents from
        any claims, damages, liabilities, costs, or expenses (including legal
        fees) arising from your use of our applications or your breach of these Terms.
      </p>

      <h2 className="font-bold text-xl mb-2">
        13. Governing Law and Dispute Resolution
      </h2>
      <p className="mb-8">
        These Terms shall be governed by and construed in accordance with the
        laws of the State of Delaware, without regard to its conflict of laws
        principles.
      </p>

      <h2 className="font-bold text-xl mb-2">14. Dispute Resolution</h2>
      <p className="mb-10">
        Any disputes arising out of or relating to these Terms shall first be
        addressed through good faith negotiations. If a resolution cannot be
        reached, the dispute shall be submitted to binding arbitration in
        accordance with the rules of a mutually agreed arbitration body, and the
        arbitration award may be entered in any court having jurisdiction.
      </p>

      <h2 className="font-bold text-xl mb-2">15. Entire Agreement</h2>
      <p className="mb-10">
        These Terms, together with our Privacy Policy, constitute the entire
        agreement regarding your use
        of our applications and supersede all prior agreements or
        understandings.
      </p>

      <h2 className="font-bold text-xl mb-2">
        16. Electronic Signatures and Acceptance
      </h2>
      <p className="mb-10">
        Your use of our applications constitutes your acceptance of our Terms.
        Your electronic acceptance of these Terms constitutes a binding
        agreement.
      </p>
    </div>
  );
}

export default PolicyholderTerms;
